// Import axios for making HTTP requests
import axios from "axios";
import { url } from "./Url";
import Encrypt from "./../util/encrypt";

// Function to call the API endpoint and get current door occupancy
const getCurrentDoorOccupancy = async (doorId) => {
  console.log("getCurrentDoorOccupancy doorid", doorId);
  const url2 = `${url.getCurrentDoorOccupancyURL}${doorId}`;
  console.log("sendRequestForGet", sendRequestForGet(url2));
  return await sendRequestForGet(url2);
};
const getCurrentSpaceOccupancy = async (doorId) => {
  console.log("getCurrentDoorOccupancy doorid", doorId);
  const url2 = `${url.getCurrentSpaceOccupancyURL}${doorId}`;
  console.log("sendRequestForGet", sendRequestForGet(url2));
  return await sendRequestForGet(url2);
};
const getLocationsForMove = async (divisionId) => {
  console.log("getLocationsForMove divisionId", divisionId);
  const url2 = `${url.locationsForMove}/${divisionId}`;
  console.log("getLocationsForMove url", sendRequestForGet(url2));
  return await sendRequestForGet(url2);
};

// const sendRequestForPostWithAuth = (Url, payload, isToken, CB) => {
//   let localstorageLR = localStorage.getItem("L_R");
//   let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
//   let loginResponse = localstorageLR
//     ? JSON.parse(data) != "" || JSON.parse(data) != null
//       ? JSON.parse(data)
//       : ""
//     : "";

//   let options = {};
//   if (payload != null && payload != "") {
//     if (isToken) {
//       options = {
//         method: "POST",
//         url: Url,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         timeout: 10000 * 3,
//         data: payload,
//       };
//     } else {
//       options = {
//         method: "POST",
//         url: Url,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: loginResponse?.token?.accessToken,
//           idToken: loginResponse?.token?.idToken,
//         },
//         timeout: 10000 * 3,
//         data: payload,
//       };
//     }
//   }
//   try {
//     return axios(options)
//       .then((response) => {
//         let responseOK = response && response.status == 200;
//         if (responseOK) {
//           CB({
//             callBackStatus: "Success",
//             data: response.data ? response.data : "",
//           });
//           return {
//             callBackStatus: "Success",
//             data: response.data ? response.data : "",
//           };
//         } else {
//           CB({
//             status: "Failed",
//             error: response.data,
//           });
//         }

//         CB({ callBackStatus: "Failed" });
//         return { callBackStatus: "Failed" };
//       })
//       .catch((e) => {
//         if (e?.response?.status && e?.response?.status == 405) {
//           if (!APICallingService.loginAlert) {
//             APICallingService.loginAlert = true;
//             alert("Please login again");
//             localStorage.clear();
//             window.location.replace("/");
//             return;
//           }
//         } else {
//           CB({ callBackStatus: "Failed" });
//           return { callBackStatus: "Failed" };
//         }
//       });
//   } catch (e) {
//     if (e?.response?.status && e?.response?.status == 405) {
//       if (!APICallingService.loginAlert) {
//         APICallingService.loginAlert = true;
//         alert("Please login again");
//         localStorage.clear();
//         window.location.replace("/");
//         return;
//       }
//     } else {
//       CB({ callBackStatus: "Failed" });
//       return { callBackStatus: "Failed" };
//     }
//   }
// };

const sendRequestForGet = (url) => {
  let localstorageLR = localStorage.getItem("L_R");
  let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
  let loginResponse = localstorageLR
    ? JSON.parse(data) != "" || JSON.parse(data) != null
      ? JSON.parse(data)
      : ""
    : "";
  let options = {};
  options = {
    method: "GET",
    url: url,
    timeout: 10000 * 3,
    headers: {
      "Content-Type": "application/json",
      Authorization: loginResponse?.token?.accessToken,
      idToken: loginResponse?.token?.idToken,
    },
  };
  try {
    return axios(options)
      .then((response) => {
        console.log("responseresponse", response);

        return {
          data: response.data ? response.data : "",
        };
      })
      .catch((e) => {
        console.log("errrorrrrrr", options, e);
      });
  } catch (e) {
    console.log("errrorrrrrr e", options, e);
  }
};
export {
  getCurrentDoorOccupancy,
  getCurrentSpaceOccupancy,
  getLocationsForMove,
};
